import { filterL, go, head, mapL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { TransformNS } from "../../../../../../Transform/TransformNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleTouchStartOnSelectorScaleCircleEl = (
  self,
  { event, origin_circle_el, x_axis_circle_el, y_axis_circle_el, scale_type }
) => {
  const selection_scale_transform1 =
    self._getSelectionScaleTransform1Throwable();
  const selection = self._getSelectionThrowable();
  event.preventDefault();
  const { targetTouches: target_touches, changedTouches: changed_touches } =
    event;
  const target_touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(target_touches),
    mapL(({ identifier }) => identifier),
    (iter) => new Set(iter)
  );
  const touch = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    filterL(({ identifier }) => target_touch_id_set.has(identifier)),
    head
  );
  if (touch == null) {
    return;
  }
  const { identifier: touch_id, clientX: client_x, clientY: client_y } = touch;
  const point = self._toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  const origin_point = CommonNS.UtilNS.getCenterPointInViewPort(self._svg_el)(
    origin_circle_el
  );
  if (origin_point == null) {
    return;
  }
  const { x: origin_x, y: origin_y } = origin_point;
  const x_axis_point = CommonNS.UtilNS.getCenterPointInViewPort(self._svg_el)(
    x_axis_circle_el
  );
  if (x_axis_point == null) {
    return;
  }
  const { x: x_axis_x, y: x_axis_y } = x_axis_point;
  const y_axis_point = CommonNS.UtilNS.getCenterPointInViewPort(self._svg_el)(
    y_axis_circle_el
  );
  if (y_axis_point == null) {
    return;
  }
  const { x: y_axis_x, y: y_axis_y } = y_axis_point;
  selection_scale_transform1.start({
    scale_type,
    x: point.x,
    y: point.y,
    origin_x,
    origin_y,
    x_axis_x,
    x_axis_y,
    y_axis_x,
    y_axis_y,
    els: [...selection.getSelectedEls()],
  });
  self._processing_task = PROCESSING_TASK.SCALE_TRANSFORMING1;
  self._scale_transforming1_touch_id = touch_id;
};
